"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackedArea = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * @internal
 */
exports.StackedArea = function (_a) {
    var className = _a.className, width = _a.width, height = _a.height, color = _a.color;
    return (react_1.default.createElement("svg", { width: width, height: height, className: className, viewBox: "0 0 24 20", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", { fill: color !== null && color !== void 0 ? color : "#B0BECA", fillRule: "evenodd" },
            react_1.default.createElement("path", { fillOpacity: ".45", d: "M0 6.94820644l3.5797762 1.76574182L11.9059481 0l7.0831473 5.01009834L24 .23762245V14.2857143H0z" }),
            react_1.default.createElement("path", { fillRule: "nonzero", d: "M0 12.6624922l3.5797762-.9993195 8.3261719-5.94888699 7.0831473 6.85347249L24 5.95190816V20H0z" }))));
};
//# sourceMappingURL=StackedArea.js.map